import React, {useState} from 'react';
//import Menu from '../../components/Menu';
import Header from '../../../components/Header';
import Footer from '../../../components/MFooter'
import Loading from '../../../components/Loading'
import {Error} from '../../../components/Erro'
import useFind from '../../../hooks/useFind'
import useForm from '../../../hooks/useForm'

import lista_grade from '../../../assets/img/icons-btns/lista-grade.png'
import lista_coluna from '../../../assets/img/icons-btns/lista-vertical.png'

// import './supervisorio.css'
import './listaM.css'
function Home () {

  return (
    <div>
      <Header/>

      {/*Conteudo*/}
      <Corpo/>

      {/* */}
      <Footer/>
    </div>
  );
}

export default Home;

const sortModos = {
    'MAIS_CADASTROS':'MAIS_CADASTROS',
    'MENOS_CADASTROS':'MENOS_CADASTROS',
    'ALFA':'ALFA',
    'ALFA_R':'ALFA_R',
}
const sortModosTexto = {
    'MAIS_CADASTROS':'Mais Cadastros',
    'MENOS_CADASTROS':'Menos Cadastros',
    'ALFA':'Ordem Alfabética',
    'ALFA_R':'Ordem Alfabética Reversa',
}
const sortModosMetodos = {
    'MAIS_CADASTROS':(x,y)=>{
        return  -x.users.length+y.users.length
    },
    'MENOS_CADASTROS':(x,y)=>{
        return x.users.length-y.users.length
    },
    'ALFA':     (a, b)=>a.nome.localeCompare(b.nome),
    'ALFA_R':   (a, b)=>b.nome.localeCompare(a.nome),
}
const sortModosLista = {
    'MAIS_CADASTROS':0,
    'MENOS_CADASTROS':0,
    'ALFA':1,
    'ALFA_R':1,
}
const listaModos={
    "COLUNA":'COLUNA',
    "GRADE":"GRADE",
}

const estados_ocultos = [
    // {"id":1,"nome":"Maranhão"},
    // {"id":2,"nome":"São Paulo"},
    {"id":3,"nome":"Astronauta"},
    // {"id":4,"nome":"Piauí"},
    // {"id":9,"nome":"Minas Gerais"},
    // {"id":5,"nome":"Bahia"},
    {"id":6,"nome":"-out"},
    {"id":11,"nome":"Marte"}
    // "3", "6", "11"
    // "Astronauta", "-out", "Marte"
]

function Corpo(){
    const { values, handleChange} = useForm({initialValues:{
            estado:"Maranhão",
            municipio:'Todos',
            sortModo: sortModos.MAIS_CADASTROS,
            // listaModo:listaModos.GRADE,
    }})

    const [listaModo, setListaModo] = useState(listaModos.GRADE)
    const [estadoId, setEstadoId] = useState(1)

    const estadosCad = useFind('estados')
    const estadoMuCad = useFind(`estados/${estadoId}/municipios/users`)

    if (estadosCad.isLoading){
        return <Loading texto = 'Carregando estados cadastrados'/>
    }
    if (estadoMuCad.isLoading){
        return <Loading texto = 'Carregando municípios cadastrados'/>
    }
    if (!!estadoMuCad.error){
        return <Error error={estadoMuCad.error.messages}/>
    }

    const dados = estadoMuCad.data.municipios.sort(sortModosMetodos[values.sortModo]);
    // mescla <td> com h = colspan; v=rowspan
    const estados = estadosCad.data.filter(e => !estados_ocultos.find(x=>x.nome===e.nome)).sort(sortModosMetodos.ALFA)

    const mock_handleChange = (event) => {
        if (event.target.name === "estado" && !estadosCad.isLoading){
            const estado_id = estadosCad.data.find(e=>e.nome===event.target.value).id
            setEstadoId(estado_id)
        }

        return handleChange(event);
    }
    //
    return (
      <div className="corpo-cadastros">
        <Menu
          values = {values}
          handleChange = {mock_handleChange}
          listaModo = {listaModo}
          setListaModo = {setListaModo}
          estados = {estados}
        />

        <ListarMunicipios
          dados = {dados}
          sortModo = {values.sortModo}
          listaModo = {listaModo}
          estados = {estados}
        />

        <Resumo
          municipios = {estadoMuCad.data.municipios}
          estados    = {estados}
          values = {values}
        />
      </div>
    );
}

function ListarMunicipios({dados,sortModo,listaModo}){

    const blocos_mun = dados.map((mun,i)=>{
        return (
          <BlocoMA
            nome={mun.nome}
            quantidade={mun.users.length}
            key={i}
            i={sortModosLista[sortModo]}
          />
        );
    })
    // const out = [];
    // for (let i=0; i<estadoMuCad.data.length-2; i=i+2){
    //     out.push(<div className="listaMBlocoA" >
    //         {estadoMuCad.data.slice(i,i+2).map((mun,i)=>{
    //             return <BlocoMA
    //                 nome={mun.nome}
    //                 quantidade={mun.users.length}
    //                 key={i}
    //                 i={i}
    //             />
    //         })}
    //     </div>)
    // }
    const modo=listaModo===listaModos.COLUNA? {flexDirection: "column",alignContent: 'center'}:{}

    return (
        <div className="listaMunicipio" style={modo}>
          {blocos_mun}
        </div>
    )
}

function Menu({municipios,estados,values,handleChange,listaModo,setListaModo}){

    function Option ({id,texto}){
        return (
            <option value={id}>{texto}</option>
        )
    }
    function Btn({img,modo}){

        return (
          <img className={`btn djbtn btn-ord ${modo===listaModo? 'btn-ord-ativado':''}`}
            alt='Listar modo Coluna' src={img}
            onClick={()=>setListaModo(modo)}
          />)
    }
    return (
        <div className="form-group form-icon centralizarAoMeio">
          <div>
            <div className="menu-op">
              <label className="select-form-label">Listar os municípios do estado:</label>
              <select name="estado" required
                value={values.estado}
                onChange={handleChange}
                // className = {values.municipio!=="Outro"? "form-input" : ""}
              >
                {estados.map(estado=><Option
                  key={`k_${estado.nome}`} id ={estado.nome} texto ={estado.nome}
                                     />
                )}
              </select>
            </div>
            <div className="menu-op">
              <label className="select-form-label">Ordenar por:</label>
              <select name="sortModo" required
                value={values.sortModo}
                onChange={handleChange}
                // className = {values.municipio!=="Outro"? "form-input" : ""}
              >
                {Object.keys(sortModos).map(modo=><Option
                  key={`k_${modo}`} id ={modo} texto ={sortModosTexto[modo]}
                                                  />
                )}
              </select>
            </div>
          </div>
          <div className="controle-btn centralizarAoMeio">
            <Btn img={lista_coluna} modo={listaModos.COLUNA}/>
            <Btn img={lista_grade} modo={listaModos.GRADE}/>
          </div>
        </div>
    )
}

function BlocoMA({nome,quantidade,i}){

    const blocoIcone = (<div className="blocoMunicipioIcone1 centralizarAoMeio">
      <div className="blocoMunicipioIcone centralizarAoMeio">{quantidade}</div>
    </div>)

    if(i%2){
        return (<div className="blocoMunicipio-b">
          <spam className="blocoMunicipioNome blocoMunicipioNome-A centralizarAoMeio">
            {nome}
          </spam>
          {blocoIcone}
        </div>)
    }else{
        return (<div className="blocoMunicipio">
          {blocoIcone}
          <spam className="blocoMunicipioNome blocoMunicipioNome-B centralizarAoMeio">
            {nome}
          </spam>
        </div>)
    }
}



function Resumo(){
    const resumo_swr = useFind('/cadastrados/resumo')

    if (resumo_swr.isLoading){
        return <Loading/>
    }
    if (!!resumo_swr.error){
        return <Error error={resumo_swr.error.messages}/>
    }

    const ResumoBloco = ({nome,mun_cadastrados,usr_cadastrados}) => {
      return (
        <tr>
          <td>{nome}</td>
          <td>{mun_cadastrados}</td>
          {/* <td>{municipios.reduce((soma, x) => soma + x.users.length, 0)}</td> */}
          <td>{usr_cadastrados}</td>
        </tr>
      );
    }

    return (
        <table>
          <thead>
            <th colspan="3">Resumo</th>
          </thead>
          <tbody>
            <tr>
              <td>Estados</td>
              <td>Municípios Cadastrados</td>
              <td>Usuários Cadastrados</td>
            </tr>
            {
              resumo_swr.data.map(({id, nome, mun_cadastrados, usr_cadastrados })=>{
                return (
                  <ResumoBloco
                    key={id}
                    nome = {nome}
                    mun_cadastrados = {mun_cadastrados}
                    usr_cadastrados = {usr_cadastrados}
                  />
                )
              })
            }
          </tbody>

          <tr>
            <th colspan="3">TOTAL</th>
          </tr>
          <tr>
            <td>Estados</td>
            <td>Municípios Cadastrados</td>
            <td>Usuários Cadastrados</td>
          </tr>
          <tr>
            <td>{resumo_swr.data.length}</td>
            <td>
              { resumo_swr.data.reduce( (s,data)=>s+data.mun_cadastrados, 0 ) }
            </td>
            <td>
              { resumo_swr.data.reduce( (s,data)=>s+data.usr_cadastrados, 0 ) }
            </td>
          </tr>
        </table>
    )
}
